const React = require('react');
const { isPrismicPreviewEnabled } = require('./prismic-preview-enabled');

let repositoryConfigs;

/**
 * Repository config for gatsby-plugin-prismic-previews v6.
 * Preview URLs use the same `linkResolver` as `gatsby-source-prismic` (see `linkResolver.js`).
 * Lazily built so `React.lazy` factories are stable across renders.
 */
function getRepositoryConfigs() {
    if (repositoryConfigs !== undefined) {
        return repositoryConfigs;
    }

    const repo = process.env.PRISMIC_REPO_NAME;
    if (!repo) {
        repositoryConfigs = [];
        return repositoryConfigs;
    }

    const { linkResolver } = require('../utils/linkResolver');
    const htmlSerializer = require('../utils/htmlSerializer');

    repositoryConfigs = [
        {
            repositoryName: repo,
            linkResolver: (doc) => linkResolver(doc),
            htmlSerializer,
            componentResolver: {
                symmetry_article: React.lazy(() => import('../templates/article')),
                symmetry_category: React.lazy(() => import('../templates/category')),
                symmetry_customer: React.lazy(() => import('../templates/customer-story')),
                symmetry_marketing_page: React.lazy(() => import('../templates/marketing-page')),
                symmetry_webinar: React.lazy(() => import('../templates/webinar-page')),
            },
        },
    ];

    return repositoryConfigs;
}

module.exports = {
    isPrismicPreviewEnabled,
    getRepositoryConfigs,
};
